export default "__VITE_ASSET__BFSM9zjA__"